module.exports = __webpack_public_path__ + "officialStatic/img/ap-detailList16.230bc1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/detail/ap-detailList16.png
// module id = zpSa
// module chunks = 0